import ConstructionIcon from '@/components/icons/ConstructionIcon';
import EngineeringAndDesignIcon from '@/components/icons/EngineeringAndDesignIcon';
import IndustrialProductSalesIcon from '@/components/icons/IndustrialProductSalesIcon';
import ManpowerIcon from '@/components/icons/ManpowerIcon';
import { pages } from './pages';

export const services = [
  {
    ...pages.construction,
    text: 'Construction',
    icon: ConstructionIcon,
  },
  {
    ...pages.manpower,
    text: 'Manpower',
    icon: ManpowerIcon,
  },
  {
    ...pages.engineeringAndDesign,
    icon: EngineeringAndDesignIcon,
  },
  {
    ...pages.industrialProductSales,
    icon: IndustrialProductSalesIcon,
  },
];
